module.exports = __webpack_public_path__ + "static/media/kelly-sikkema-4JxV3Gs42Ks_small.45d93ea6.jpg";